<!-- Translated: skip -->
<template>
  <div class="component">
    <div class="body" v-if="!$store.state.accomodationsFilter.freeSearch" @click.stop="expand()">
      <div class="image default-image" :style="(pool && (pool.image_thumbnail || pool.image)) ? 'background-image:url(' + (pool.image_thumbnail || pool.image) + ')' : 'background-size: cover;'">
        <button v-if="!pool.hide_map" class="link" @click.stop="openMap()" :aria-label="pool.units[0].facility ? 'Öppna karta över ' + locations[pool.units[0].facility.id].title : 'Öppna karta över området'">
          <icon name="map" scale="2.1" />
        </button>
        <button v-if="pool.video" class="link" @click.stop="openMovie()" :aria-label="'Starta film som visar ' + (pool.display_name || pool.name)">
          <icon name="film" scale="2.1" />
        </button>
        <button class="link" @click.stop="openLocationInfo()" v-if="SITE_CONFIG.accomodations.show_site && pool.units[0].facility && locations[pool.units[0].facility.id]" :aria-label="'Läs mer information om ' + (locations[pool.units[0].facility.id].title)">
          <icon :name="locations[pool.units[0].facility.id].slug" scale="2.1" />
        </button>
      </div>
      <div class="details">
        <div class="details-start">
          <p class="area-title" aria-hidden="true">Område:</p>
          <h2>
            {{ (pool.display_name || pool.name) }}
          </h2>
          <div class="description">
            <p>{{pool.short_description}}</p>
          </div>
          <ul class="features" v-if="bulletPoints.length" :aria-label="(pool.display_name || pool.name) + ' i korthet'">
            <li v-for="point in bulletPoints"><span>{{point}}</span></li>
          </ul>
        </div>
        <div class="details-end">
          <button v-if="!pool.hide_map" class="link" @click.stop="openMap()" :aria-label="pool.units[0].facility ? 'Öppna karta över ' + locations[pool.units[0].facility.id].title : 'Öppna karta över området'">
            <icon name="map" scale="2.1" />
            <br>
            Karta
          </button>
          <button v-if="pool.video" class="link" @click.stop="openMovie()" :aria-label="'Starta film som visar ' + (pool.display_name || pool.name)">
            <icon name="film" scale="2.1" />
            <br>
            Film
          </button>
          <button class="link" @click.stop="openLocationInfo()" v-if="pool.units[0].facility && locations[pool.units[0].facility.id]" :aria-label="pool.units[0].facility ? 'Läs mer information om ' + (locations[pool.units[0].facility.id].title) : 'Läs mer information om området'">
            <icon :name="locations[pool.units[0].facility.id].slug" scale="2.1" />
            <br>
            {{locations[pool.units[0].facility.id].title}}
          </button>
          <button class="link" @click.stop="openAreaMap()" v-if="pool.map_link" :aria-label="'Öppna karta över ' + (pool.display_name || pool.name)">
            <icon name="pdf-blue" scale="2.1" />
            <br>
            Områdeskarta
          </button>

          <div class="price" v-if="lowestUnitPrice > 0">
            <span class="label">Pris från</span>
            <span class="value">
              {{ lowestUnitPrice | currency }}
            </span>
          </div>
          <!-- <div class="price" v-if="!accomodationsFilterEndDate && pool.price_from">
            <span class="label">Pris från</span>
            <span class="value">{{ pool.price_from | currency }}</span>
          </div> -->
        </div>
      </div>
    </div>
    <AccomodationsListUnitsGroup v-if="SITE_CONFIG.accomodations.display_as_group_pools[pool.id]" ref="unitList" :pool="pool" />
    <AccomodationsListUnitsList v-if="!SITE_CONFIG.accomodations.display_as_group_pools[pool.id]" ref="unitList" :units="pool.units" />
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import AccomodationsListUnitsList from '@/components/parts/Accomodation/List/AccomodationsListUnitsList';
import AccomodationsListUnitsGroup from '@/components/parts/Accomodation/List/AccomodationsListUnitsGroup';
import {
  filter,
} from 'lodash/fp';
import {
  filterUnit,
} from '@/lib';

import moment from 'moment';

export default {
  props: ['pool', 'locations'],
  components: {
    AccomodationsListUnitsList,
    AccomodationsListUnitsGroup,
  },
  computed: {
    ...mapGetters([
      'accomodationsFilterEndDate',
      'accomodationsFilter',
    ]),
    bulletPoints() {
      if (this.pool.bullet_points) {
        const pool = this.pool.bullet_points || '';
        return pool.split('\n');
      }
      return [];
    },
    filteredUnits() {
      const unitFilter = filterUnit(this.$store.state.accomodationsFilter);
      return filter(unitFilter, this.pool.units);
    },
  },
  watch: {
    accomodationsFilter() {
      this.calculateLowestUnitPrice();
    },
  },
  data() {
    return {
      lowestUnitPrice: 0,
    };
  },
  mounted() {
    setTimeout(this.calculateLowestUnitPrice, 1);
  },
  methods: {
    ...mapMutations([
      'openModal',
    ]),
    calculateLowestUnitPrice() {
      let lowest = 999999;
      if (!window.prices) {
        window.prices = {};
      }

      this.filteredUnits.forEach((unit) => {
        if (this.accomodationsFilterEndDate) {
          if (window.prices[unit.id] && window.prices[unit.id] &&
            window.prices[unit.id].price < lowest) {
            lowest = window.prices[unit.id].price;
          }
        } else if (unit.price_from && unit.price_from < lowest) {
          lowest = unit.price_from;
        }
      });

      if (lowest !== 999999) {
        this.lowestUnitPrice = lowest;
      } else {
        this.lowestUnitPrice = 0;
      }
    },
    openMap() {
      console.log(this.pool);
      this.openModal([`MapModal${this.SITE_CONFIG.site}`, {
        locationId: (this.pool.units[0].facility ? this.pool.units[0].facility.id : null),
        areaId: this.pool.id,
        type: 'view',
      }]);
    },
    moment(d) {
      return moment(d);
    },
    openMovie() {
      this.openModal(['MovieModal', {
        url: this.pool.video,
      }]);
    },
    openAreaMap() {
      window.open(this.pool.map_link);
    },
    openLocationInfo() {
      this.openModal(['GeneralModal', {
        title: this.locations[this.pool.units[0].facility.id].title,
        content: this.locations[this.pool.units[0].facility.id].content,
      }]);
    },
    expand() {
      this.$refs.unitList.isManuallyExpanded = !this.$refs.unitList.isManuallyExpanded;
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'


.component
  margin-top space-3



.body
  background-color white
  display flex
  align-items flex-start
  shadow()
  padding space-1
  cursor pointer
  +max-mobile()
    flex-wrap: wrap
    padding-left 10px
    padding-right 10px
  p
    margin-bottom: 5px

.image
  background-color #fff
  width 300px
  padding-top: 20%
  background-size cover
  background-position center
  flex-basis: initial
  +max-mobile()
    width 100%
    padding-top 48%
    // height 140px
  & > *
    display none
    +max-mobile()
      display inline-block
      background-color white
      border-radius: 50%
      margin-top 8px
      margin-left 8px
      width 40px
      height 40px
      font-size 19px
      display: none;

.details
  display flex
  width calc(100% - 300px)
  flex-direction: column;
  padding-left space-3
  padding-right space-3
  align-self stretch
  +max-mobile()
    width 100%
    padding-left padding-mobile
    padding-right padding-mobile
  h2
    united-heavy()
    font-size 22px
    text-transform uppercase
    margin-top 0
    margin-bottom 3px
    +max-mobile()
      font-size: 18px

.details-start
  flex 1 0 auto
  p
    font-size: 14px
    line-height: 1.3em
    margin-bottom: 10px
  p.area-title
    color gray
    font-size 9px
    font-weight 300
    letter-spacing 0.4px
    color #474747
    margin 0 0 5px 0
    text-transform uppercase
    margin-top space-1

.description
  color gray

.features
  max-width 500px
  column-width 250px
  column-gap 0
  list-style none
  padding-left 0
  li
    padding-left 1em
    padding-right 1em
    margin-bottom space-half
    &:before
      display inline-block
      content '●'
      color deep-blue
      width 1em
      margin-left -1em

.details-end
  flex 0 0 auto
  display flex
  margin - space-2
  text-align: center;
  margin-top: 10px
  +max-tablet()
    flex-wrap: wrap;

  .link
    util-reset-button()
    padding: 0px 20px 15px;
    font-weight bold
    font-size 10px
    &:hover
      font-size 10px
    text-transform uppercase
    cursor pointer
    centered()
    +max-mobile()
      display none
    .icon
      margin-bottom: 3px
  .price
    margin-left auto
    padding space-2
    +max-mobile()
      margin-left 0
      padding: 0px 10px 20px 10px
    .label
      font-size 11px
      color silver-darker
    .value
      font-weight bold
      font-size 20px
      padding-left space-1

</style>



// WEBPACK FOOTER //
// AccomodationsListPool.vue?13098ebc